import { IGNIS_RED } from "@120wateraudit/waterworks";
import React, { useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import styled from "styled-components";

interface OverdueDropdownProps {
  handleRemoveOverdue: () => void;
}

const OverdueDropdown: React.FC<OverdueDropdownProps> = ({
  handleRemoveOverdue,
}) => {
  const [isSelectionOpen, setIsSelectionOpen] = useState(false);

  const handleOpen = (): void => {
    setIsSelectionOpen(!isSelectionOpen);
  };

  const onRemoveOverdue = (): void => {
    handleRemoveOverdue();
    setIsSelectionOpen(false);
  };

  const overdueOptions = [
    {
      key: "removeOverdue",
      text: "Remove Overdue",
      value: "removeOverdue",
    },
  ];

  return (
    <div style={{ marginLeft: 10, paddingTop: 3, paddingBottom: 3 }}>
      <StyledButton
        options={["Remove Overdue"]}
        onClick={handleOpen}
        style={{
          backgroundColor: `${IGNIS_RED}`,
          color: "white",
          textAlign: "center",
          padding: 10,
        }}
      >
        Overdue
        <Icon name="dropdown" style={{ textAlign: "right" }} />
      </StyledButton>
      {isSelectionOpen && (
        <DropdownContainer>
          {overdueOptions.map((option) => (
            <DropdownOption
              key={option.key}
              onClick={() => onRemoveOverdue()}
              onKeyDown={(e: React.KeyboardEvent) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onRemoveOverdue();
                }
              }}
              tabIndex={0}
            >
              {option.text}
            </DropdownOption>
          ))}
        </DropdownContainer>
      )}
    </div>
  );
};

const StyledButton = styled(Button)`
  background-color: ${IGNIS_RED};
  color: white;
  font-weight: 600;
`;

const DropdownContainer = styled.div`
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-top: 5px;
  position: absolute;
  z-index: 1000;
`;

const DropdownOption = styled.div`
  cursor: pointer;
  padding: 8px;
  &:hover {
    background-color: #f1f1f1;
  }
`;

export default OverdueDropdown;
